import { useState } from 'react';
import RequestService from '../../../../services/RequestService';
import SubCategoryForm from '../../../../components/forms/subCategory/SubCategoryForm';
import { ToastContainer } from 'react-toastify';
import Breadcrumb from '../../../../components/Breadcrumb/Breadcrumb';
import { useParams } from 'react-router-dom';

import 'react-toastify/dist/ReactToastify.css';

const SubCategoryCreate = () => {
  const { id } = useParams();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onSubmit = async (data: any) => {
    setIsSubmitting(true);
    const requestService = new RequestService(
      `/api/v1/admin/category/${id}/sub`
    );
    await requestService.post(data);
    setIsSubmitting(false);
  };

  const breadcrumbs = {
    url: process.env.REACT_APP_CLIENT_URL,
    type: 'BreadcrumbList',
    name: 'تیداکو',
    itemListElement: [
      {
        id: 'http://admin.tidaco.co/main',
        type: 'ListItem',
        position: 1,
        item: {
          id: 'http://admin.tidaco.co/main',
          url: 'http://admin.tidaco.co/main',
          name: 'صفحه اصلی ',
        },
      },
      {
        id: 'http://admin.tidaco.co/category/list',
        type: 'ListItem',
        position: 2,
        item: {
          id: 'http://admin.tidaco.co/category/list',
          url: 'http://admin.tidaco.co/category/list',
          name: 'لیست دسته‌بندی',
        },
      },
      {
        id: 'http://admin.tidaco.co/category/list',
        type: 'ListItem',
        position: 3,
        item: {
          id: 'http://admin.tidaco.co/category/create',
          url: 'http://admin.tidaco.co/category/create',
          name: 'ایجاد دسته‌بندی',
        },
      },
    ],
  };

  return (
    <div>
      <div className="p-5">
        <Breadcrumb breadcrumbs={breadcrumbs} />
      </div>
      <ToastContainer />
      <div>
        <SubCategoryForm
          isSubmitting={isSubmitting}
          onSubmit={onSubmit}
          formTitle="ایجاد زیردسته"
          buttonTitle="ثبت"
        />
      </div>
    </div>
  );
};

export default SubCategoryCreate;
